import * as Yup from 'yup';

const newRegistro = {
    identificacao: '',
    status: true,
    categoriaAtual: null,
    genero: null,
    raca: null,
    pelagem: null,
    obs: '',
};

const validation = Yup.object().shape({
    identificacao: Yup.string()
        .min(2, 'O campo deve ter no mínimo 2 caracteres')
        .max(100, 'Campo deve ter menos do que 100 caracteres')
        .required('Este campo é obrigatório'),
    categoriaAtual: Yup.object()
        .typeError('Este campo é obrigatório')
        .shape({
            id: Yup.number()
                .typeError('Este campo é obrigatório')
                .required("Este campo é obrigatório"),
        }),
    genero: Yup.string()
        .typeError('Este campo é obrigatório')
        .required('Este campo é obrigatório'),
    obs: Yup.string()
        .min(2, 'O campo deve ter no mínimo 2 caracteres')
        .max(1000, 'Campo deve ter menos do que 1000 caracteres'),
});

export const animalCadastro = {
    newRegistro,
    validation
}